/* @flow */

import * as React from 'react';
import noop from 'lodash/noop';
import useSheet from 'app/jss';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';
import Responsive from 'app/components/responsive/Responsive';
import Card from 'app/components/commons/Card';
import FriendCompactDetails from 'app/components/friends/friendCard/FriendCompactDetails';
import * as CardSizes from 'app/constants/friendCardSizes';
import FriendOpenCard from 'app/components/friends/friendCard/FriendOpenCard';

type Props = {
  disabled?: boolean,
  friend: Friend | FriendRequest | User,
  onClick?: () => void,
  classes: Object,
  size?: number,
  children?: any,
};

type State = {
  // whether or not the card is open
  isOpen: boolean,
  // whether or not we're changing from open to closed, or closed to open
  sizeChanging: boolean,
};

class FriendCard extends React.Component<Props, State> {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: props.size !== CardSizes.COMPACT,
      sizeChanging: false,
    };
  }

  static defaultProps = {
    disabled: false,
    onClick: noop,
    selected: false,
    showCornerTag: false,
    size: CardSizes.COMPACT,
    children: undefined,
  };

  render() {
    const { disabled, friend, onClick, classes, size, children } = this.props;

    return (
      <Card className={classes.friendCard}>
        {children}
        <Responsive mobile tabletPortrait={false}>
          {isMobile => (
            <AnimatedGroup
              onEnter={Enter.appear(0.3, 0.3)}
              onLeave={Leave.disappear(0.3)}
              className={classes.friendContents}
            >
              <div className={classes.detailsWrapper} key={size}>
                {(size === CardSizes.COMPACT || isMobile) && (
                  <FriendCompactDetails
                    friend={friend}
                    avatar={friend.avatar}
                    disabled={disabled}
                    onClick={() => onClick(friend)}
                    status={friend.status}
                    username={friend.username}
                  />
                )}
                {size !== CardSizes.COMPACT &&
                  !isMobile && <FriendOpenCard friend={friend} onClick={onClick} />}
              </div>
            </AnimatedGroup>
          )}
        </Responsive>
      </Card>
    );
  }
}

function applyStyles(theme) {
  return {
    friendCard: {
      position: 'relative',
      overflow: 'hidden',
      height: '100%',
      width: '100%',
      display: 'flex',
      fontSmoothing: 'antialiased',
    },
    detailsWrapper: {
      overflow: 'hidden',
      borderRadius: 8,
      height: '100%',
      width: '100%',
    },
    friendContents: {
      flexGrow: 1,
      // safari needs height
      height: '100%',
      overflow: 'hidden',
    },
  };
}

export default useSheet(applyStyles)(FriendCard);
